import FieldWrapper from "../../FieldWrapper";
import {FormControl, IconButton, makeStyles, Tooltip, Typography} from "@material-ui/core";
import {useEffect, useState, useMemo} from "react";
import {setArrayPath} from "../../Utils/setArrayPath";
import findByString from "../../Utils/getValueByString";
import Button from "@material-ui/core/Button";
import IconsSelectionModal from "./IconsSelectionModal";
import IconComponent from "../../../../../Components/JsonScreen/Screen/ScreenComponents/IconComponent";

const useStyles = makeStyles(() => ({
    formControl: {
        minWidth: 'auto'
    },
}))

const transformToName = (id) =>{

    if(typeof id !== "string") return

    return id.split('_')
        .map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
        .join(' ');
}

const IconSelectType = (props) => {
    const classes = useStyles();
    const {
        field,
        setValue,
        labelStyles,
        fieldStyles,
        showLabel,
        values,
        containerArrayPath
    } = props;
    const [path, setPath] = useState(field.path)
    const [isOpenModal, setIsOpenModal] = useState(false)
    const arrayPath = useMemo(() => setArrayPath(field.path, containerArrayPath), [field.path, containerArrayPath]);
    const value = useMemo(() => {
        return findByString(values, arrayPath ?? field.path) ?? {};
    }, [values, arrayPath, field.path]);

    useEffect(() => {
        setPath(arrayPath ? arrayPath : field.path);
    }, [field.path, arrayPath]);


    function onSubmit(icon, iconType) {
        setValue({...value, icon, iconType}, path)
        // setValue(icon, path + '.icon')
        // setValue(iconType, path + '.iconType')
        setIsOpenModal(false)
    }

    function clearValue() {
        setValue({...value, icon: undefined, iconType: undefined}, path)
    }


    return (
        <FieldWrapper
            label={field.label}
            labelStyles={labelStyles}
            fieldStyles={fieldStyles}
            path={field.path}
            showLabel={showLabel}
        >
            <FormControl classes={{root: classes.formControl}}
                         style={{width: fieldStyles.fullWidth ? '100%' : fieldStyles.width}}
                         fullWidth={fieldStyles.fullWidth}>
                <Button size={'small'} variant={'outlined'}
                        style={{marginTop: 3, marginLeft: 2}}
                        onClick={() => setIsOpenModal(true)}>
                    {value.icon ?
                        <div style={{
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'space-between',
                            gap: 10,
                            width: '100%'
                        }}>
                            <div
                                style={{
                                    display: 'flex',
                                    alignItems: 'center',
                                    gap: 10
                                }}
                            >
                                <IconComponent
                                    component={{
                                        properties: {
                                            icon: value.icon,
                                            iconType: value.iconType
                                        }
                                    }}
                                />
                                <Typography style={{fontSize: 14}} color="textSecondary">
                                    {transformToName(value.icon)}
                                </Typography>
                            </div>
                            <div style={{
                                display: 'flex',
                                alignItems: 'center',
                            }}>
                                <Tooltip title={'delete icon'}>
                                <IconButton
                                    onClick={(e) => {
                                        clearValue();
                                        e.stopPropagation();
                                    }}
                                    style={{
                                        padding: 0
                                    }}
                                    size={'small'}
                                >

                                        <IconComponent
                                            component={{
                                                properties: {
                                                    icon: 'clear',
                                                    iconType: 'outlined'
                                                },
                                                styles: [{
                                                    fontSize: '1.2rem',
                                                }]
                                            }}
                                        />
                                </IconButton>
                                </Tooltip>
                            </div>
                        </div>
                        : 'Select Icon'}
                </Button>
                <IconsSelectionModal
                    isOpen={isOpenModal}
                    onClose={() => setIsOpenModal(false)}
                    onSubmit={onSubmit}
                    value={{
                        icon: value.icon,
                        iconType: value.iconType
                    }}
                />
            </FormControl>
        </FieldWrapper>
    )
}

export default IconSelectType;
